module.exports = __webpack_public_path__ + "assets/img/all_product_banner.44b17e2d.png";